export default __webpack_public_path__ + "fad675f1b4170c9ee40a00212aba989a.png";